/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_series_skew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC skew`)
};

const es_gcskew_series_skew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesgo GC`)
};

const de_gcskew_series_skew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-Skew`)
};

const nl_gcskew_series_skew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-skew`)
};

const fr_gcskew_series_skew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biais GC`)
};

const it_gcskew_series_skew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skew GC`)
};

const pt_br2_gcskew_series_skew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC skew`)
};

const pt_gcskew_series_skew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assimetria GC`)
};

const ja_gcskew_series_skew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GCスキュー`)
};

const zh_gcskew_series_skew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC 偏斜`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_series_skew = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_series_skew(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_series_skew", locale)
	if (locale === "en") return en_gcskew_series_skew(inputs)
	if (locale === "es") return es_gcskew_series_skew(inputs)
	if (locale === "de") return de_gcskew_series_skew(inputs)
	if (locale === "nl") return nl_gcskew_series_skew(inputs)
	if (locale === "fr") return fr_gcskew_series_skew(inputs)
	if (locale === "it") return it_gcskew_series_skew(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_series_skew(inputs)
	if (locale === "pt") return pt_gcskew_series_skew(inputs)
	if (locale === "ja") return ja_gcskew_series_skew(inputs)
	return zh_gcskew_series_skew(inputs)
};